import { render, staticRenderFns } from "./ProductResistrationInquiryModal.vue?vue&type=template&id=ee5654f6&scoped=true&lang=pug&"
import script from "./ProductResistrationInquiryModal.vue?vue&type=script&lang=ts&"
export * from "./ProductResistrationInquiryModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductResistrationInquiryModal.vue?vue&type=style&index=0&id=ee5654f6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5654f6",
  null
  
)

export default component.exports